import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useEffectOnce from "../../chat/useEffectOnce";
import { socket } from "../../constants/global";
import authContext from "../../context/auth/authContext";
import { Toaster } from "../../entity/GlobalJS";
const Logout = () => {
    const user = JSON.parse(localStorage.getItem('lmsuser'));
    if(user){
        socket.emit('logout',{userId:user.id});
    }
    const navigate = useNavigate();
    const cntxAuth = useContext(authContext);
    localStorage.setItem('lmsuser', JSON.stringify({}));
    localStorage.removeItem('lmstoken');
    localStorage.removeItem('lmsuser');
    localStorage.removeItem('profile');
    localStorage.removeItem('learningCircleUniqueId');
    localStorage.removeItem('enrolling');
    useEffect(() => {
        cntxAuth.updateLogin(false);
        navigate("/login");    
        //eslint-disable-next-line
    }, []);
    useEffectOnce(() => {
        cntxAuth.updateMessage({ message: "You are successfully logged out.", type: 'success' });
    })
    
    return (
        <></>
    );
}

export default Logout;